module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"jquery","commonjs2":"jquery","amd":"jquery","root":"$"}
// module id = 0
// module chunks = 0